import axios from 'axios';

export default {
  namespaced: true,
  state: {
    latLng: null,
  },
  getters: {
  },
  mutations: {
    setLatLng(state, latLng) {
      state.latLng = latLng;
    },
  },
  actions: {
    async retriveAddressByLatLng(context, data) {
      try {
        const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${data.lat}&lon=${data.lng}&accept-language=en`, { withCredentials: false });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async retriveLatLngByAddress(context, data) {
      try {
        const response = await axios.get(`https://nominatim.openstreetmap.org/search?format=jsonv2&accept-language=en${data.county ? `&county=${data.county}` : ''}${data.state ? `&state=${data.state}` : ''}${data.city ? `&city=${data.city}` : ''}`, { withCredentials: false });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
